// eslint-disable-next-line import/no-unresolved
import { union } from 'lodash';
import { Options as SentryOptions } from '@sentry/types';
import { BrowserOptions } from '@sentry/browser';

import { getSentryReleaseId } from './sentry-release-tag';

// these are a bunch of common errors that sentry recommends ignoring:
// https://docs.sentry.io/clients/javascript/tips/
const commonErrors = [
  'top.GLOBALS',
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  'fb_xd_fragment',
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  'conduitPage',
];

// these errors are specific to autolist and we think are related to ads
const adsErrors = [
  'NS_ERROR_NOT_INITIALIZED',
  'setTimeout(u,e)',
  'clearTimeout(f)',
  "Object is not a function. (In 'Object(t)', 'Object' is undefined)",
  /^Error Object expected http/,
];

// other errors that are specific to autolist but we want to ignore them
const miscErrors = [
  // Firebase throws these errors when there are network connection issues
  'Network Error',
  'A network error (such as timeout, interrupted connection or unreachable host) has occurred.',
];

const ignoreErrors = union(commonErrors, adsErrors, miscErrors);

const whitelistUrls = [
  /autolist-web-.*\.herokuapp\.com/,
  /experimental\.autolist\.com/,
  /sentry\.io/,
  /getsentry\.com/,
  /cdn\.getsentry\.com/,
  /www\.autolist\.com/,
  /autolist\.com/,
  /.*-proxy\.autolist\.com/,
  /googlemaps\.autolist\.com/,
  /production-assets\d+\.autolist\.com/,
];

const localUrlRegexp = /localhost|file:\/\/\/|webpack-internal:\/\/\//;

export function getClientSentryConfig(): BrowserOptions {
  if (window.location.hostname === 'localhost') {
    return { ignoreErrors, whitelistUrls: [...whitelistUrls, localUrlRegexp] };
  }
  return { ignoreErrors, whitelistUrls };
}

export function getCommonSentryConfig(): SentryOptions {
  return {
    environment: process.env.SENTRY_ENVIRONMENT || 'staging',
    dsn: process.env.RAVEN_JS_DSN,
    tracesSampleRate: 0.075,
    release: getSentryReleaseId(),
    debug: process.env.SENTRY_DEBUG === 'true',
  };
}
